import React, { useState } from "react";
import { ModalButtonWrap, ModalBody } from "./Modal";
import icFolder from "../../assets/images/icons/ic-folder.png";
import { RoundButton } from "../common";
import "./style/_folder-id-update-modal.scss";
import { useMutation, useQuery } from "@tanstack/react-query";
import folderManager from "../../apis/folderManager";
import bannerGroupManager from "../../apis/bannerGroupManager";
import { showToast } from "../../redux/ToastSlice";
import { setGlobalLoading } from "../../redux/GlobalLoadingSlice";
import { useDispatch } from "react-redux";

const FolderIdUpdateModal = ({ handleCloseModal, bannerIds, refetchBanners, setCheckItems }) => {
    const [folderName, setFolderName] = useState("폴더 선택 없음");
    const [selectedId, setSelectedId] = useState(null);
    const dispatch = useDispatch();

    const { data: folders, refetch } = useQuery({
        queryKey: ["getFolders"],
        queryFn: folderManager.getFolders,
    });

    const onCancelClick = () => {
        handleCloseModal();
    };

    const onSelectFolder = (folder) => {
        setSelectedId(folder.id);
        setFolderName(folder.title);
    }

    const onMoveClick = () => {
        if(selectedId && bannerIds && bannerIds.length > 0) {
            return updateFolderIdMutation.mutate({ folderId: selectedId, bannerIds });
        } else {
            return dispatch(showToast("폴더를 선택해주세요."));
        }
    }

    const updateFolderIdMutation = useMutation(
        bannerGroupManager.updateFolderId,
        {
            onSuccess: () => {
                setCheckItems([]);
                refetchBanners();
                handleCloseModal();
                dispatch(showToast("배너가 이동되었습니다."));
            },
            onError: () => {
                dispatch(setGlobalLoading(false));
            },
        }
    );

    return (
        <ModalBody id="FolderIdUpdateModalContent">
            <div className="folder_wrap">
                <div className="folder_txt">
                    <span>Move to</span>
                </div>
                <div className="floder_name">
                    <div className="name_text">
                        {folderName}
                    </div>
                </div>
            </div>
            <div className="list_wrap">
                {folders?.map((folder, idx) => (
                    <div
                        className={`folder_row ${folderName === folder.title ? 'active' : ''}`}
                        key={idx}
                        onClick={() => onSelectFolder(folder)}
                    >
                        <img src={icFolder} alt="Folder" />
                        <p>{folder.title}</p>
                    </div>
                ))}
            </div>

            <ModalButtonWrap className="cancel_save">
                <RoundButton type={"outline"} onClick={onCancelClick}>
                    취소
                </RoundButton>
                <RoundButton
                    type={"fill"}
                    onClick={onMoveClick}
                    isDisabled={folderName === "폴더 선택 없음"}
                >
                    이동
                </RoundButton>
            </ModalButtonWrap>
        </ModalBody>
    );
};

export default FolderIdUpdateModal;
